import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';

var AppAutoComplete = /*#__PURE__*/function (_Vue) {
  _inherits(AppAutoComplete, _Vue);

  var _super = _createSuper(AppAutoComplete);

  function AppAutoComplete() {
    var _this;

    _classCallCheck(this, AppAutoComplete);

    _this = _super.apply(this, arguments);
    _this.model = [];
    _this.showPWD = false;
    _this.rules = {
      required: function required(value) {
        return !!value || '不能为空！';
      },
      text: function text() {
        return true;
      }
    };
    return _this;
  }

  _createClass(AppAutoComplete, [{
    key: "mounted",
    value: function mounted() {
      this.model = this.value;
    }
  }, {
    key: "remove",
    value: function remove(item) {
      var index = this.value.indexOf(item);
      if (index >= 0) this.model.splice(index, 1);
    }
  }, {
    key: "onModelChanged",
    value: function onModelChanged() {
      this.valueChangedHandler();
    }
  }, {
    key: "valueChangedHandler",
    value: function valueChangedHandler() {
      return this.model;
    }
  }]);

  return AppAutoComplete;
}(Vue);

__decorate([Prop({
  type: Array
})], AppAutoComplete.prototype, "value", void 0);

__decorate([Prop(String)], AppAutoComplete.prototype, "label", void 0);

__decorate([Prop({
  type: String
})], AppAutoComplete.prototype, "placeholder", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], AppAutoComplete.prototype, "required", void 0);

__decorate([Prop({
  type: [Number, String],
  default: '289'
})], AppAutoComplete.prototype, "width", void 0);

__decorate([Prop({
  type: [Number, String],
  default: 36
})], AppAutoComplete.prototype, "height", void 0);

__decorate([Prop({
  type: String
})], AppAutoComplete.prototype, "confirm", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], AppAutoComplete.prototype, "autofocus", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], AppAutoComplete.prototype, "disabled", void 0);

__decorate([Prop({
  type: Array
})], AppAutoComplete.prototype, "items", void 0);

__decorate([Watch('model')], AppAutoComplete.prototype, "onModelChanged", null);

__decorate([Emit('input')], AppAutoComplete.prototype, "valueChangedHandler", null);

AppAutoComplete = __decorate([Component], AppAutoComplete);
export default AppAutoComplete;